import * as React from "react";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import './searchBarComponent.css';
import { useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

function SearchBarComponent() {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = React.useState("");

  const handleOptionChange = (event) => {
    const selected = event.target.value;
    setSelectedOption(selected);
    
    // Navigate based on the selected option
    switch (selected) {
      case "option1":
        navigate("/liceses");
        break;
      case "option2":
        navigate("/Software");
        break;
      case "option3":
        navigate("/SalesOrder");
        break;
      case "option4":
        navigate("/liceses");
        break;
      default:
        break;
    }
  };

  return (
    <>
    <div className="search-bar">
      <Paper
        component="form"
        sx={{
          p: "2px 4px",
          display: "flex",
          alignItems: "center",
          borderRadius: "22px",
          backgroundColor: "#F5F9FD",
          boxShadow: "none"
        }}
      >
        <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
          <SearchIcon />
        </IconButton>
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder="Search"
          inputProps={{ "aria-label": "search" }}
        />
        <Select
        className="dropdown-container"
          value={selectedOption}
          onChange={handleOptionChange}
          displayEmpty
          inputProps={{ "aria-label": "select option" }}
          // IconComponent={() => (
          //   <KeyboardArrowDownIcon sx={{color: "#FFF7E0",background:"#334456",borderRadius:"50%",cursor:"pointer"}} />
          // )}
        >
     
          <MenuItem value="option1">License</MenuItem>
          <MenuItem value="option2">Software</MenuItem>
          <MenuItem value="option3">Order #</MenuItem>
          <MenuItem value="option4">Company</MenuItem>
        </Select>
      </Paper>
    </div>
    </>
  );
}
export default SearchBarComponent;

